 
      // Popup Open and close
  function openPopup() {
    document.getElementById('myPopup').style.display = 'flex';
  }

  function closePopup() {
    document.getElementById('myPopup').style.display = 'none';
  }




 // Selected Button Class ADD and REMOVE

function selectButton(buttonId) {
    const pair1 = ['simba2Btn', 'appaBtn'];
    const pair2 = ['simbaBtn', 'gatoBtn'];

    let currentPair;
    if (pair1.includes(buttonId)) {
        currentPair = pair1;
    } else if (pair2.includes(buttonId)) {
        currentPair = pair2;
    } else {
        return;
    }

    // Deselect only within the same pair
    currentPair.forEach(id => {
        document.getElementById(id)?.classList.remove('selected-btn');
    });

    // Select the clicked button
    document.getElementById(buttonId)?.classList.add('selected-btn');
}






    
   // --- Saves Main Swap button and Adds SHowme in th eselcted div ---
  

 document.addEventListener('DOMContentLoaded', () => {
    // --- Constants ---
    const ACTIVE_CLASS = 'active-text0001';
    const STORAGE_KEY = 'activeButtonId'; 
    const BUTTON_CONTAINER_SELECTOR = '.button-container0001';
    const SHOW_CLASS = 'showme';

    const buttons = document.querySelectorAll(`${BUTTON_CONTAINER_SELECTOR} button`);
    const perroContainer = document.querySelector('.product-option-settings.perroxxcp');
    const gatoContainer = document.querySelector('.product-option-settings.gatoxxcp');

    function saveActiveButtonState() {
        const active = document.querySelector('.' + ACTIVE_CLASS);
        if (active) {
            localStorage.setItem(STORAGE_KEY, active.id);
            applyActiveContentClass(active.id);
        }
    }

    function clearContentClasses() {
        if (perroContainer) perroContainer.classList.remove(SHOW_CLASS);
        if (gatoContainer) gatoContainer.classList.remove(SHOW_CLASS);
    }

    function applyActiveContentClass(buttonId) {
        const activeId = buttonId || localStorage.getItem(STORAGE_KEY);
        
        if (!activeId) return;

        clearContentClasses(); 

        if (activeId === 'perroButton0001' && perroContainer) {
            perroContainer.classList.add(SHOW_CLASS);
        } else if (activeId === 'gatoButton0001' && gatoContainer) {
            gatoContainer.classList.add(SHOW_CLASS);
        }
    }

    // ------------------------------------------
    // --- Core Logic ---
    // ------------------------------------------

    applyActiveContentClass(null); 
    
    saveActiveButtonState();

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            setTimeout(saveActiveButtonState, 0);
        });
    });
});













// Show right extra pet button only on submit button click


document.addEventListener('DOMContentLoaded', () => {
    // --- Constants ---
    const ACTIVE_CLASS = 'active-text0001';
    const STORAGE_KEY = 'activeButtonId'; 
    const BUTTON_CONTAINER_SELECTOR = '.button-container0001';
    const HIDDEN_CLASS = 'd-none'; // The class to remove for showing content

    // --- Elements ---
    const buttons = document.querySelectorAll(`${BUTTON_CONTAINER_SELECTOR} button`);
    const submitBtn = document.getElementById('submitBtn');
    
    // Select the content containers (assuming they exist and start with d-none)
    const perroContent = document.querySelector('.perroxp');
    const gatoContent = document.querySelector('.gatoxp');


    /**
     * Finds the currently active button and saves its ID to localStorage.
     */
    function saveActiveButtonState() {
        const active = document.querySelector('.' + ACTIVE_CLASS);
        if (active) {
            localStorage.setItem(STORAGE_KEY, active.id);
        }
    }

    /**
     * Hides all target content elements.
     */
    function hideAllContent() {
        if (perroContent) perroContent.classList.add(HIDDEN_CLASS);
        if (gatoContent) gatoContent.classList.add(HIDDEN_CLASS);
    }

    // --- Core Button Tracking Logic ---

    // 1. COLLECT AND SAVE ON PAGE LOAD
    saveActiveButtonState();

    // 2. COLLECT AND SAVE ON CHANGE (Button Click)
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            // A short delay (setTimeout 0) ensures we read the DOM *after* the active class has been updated.
            setTimeout(saveActiveButtonState, 0);
        });
    });

    // -------------------------------------------------------------------
    // --- LOGIC FOR SUBMIT BUTTON: Console Log & Class Toggle ---
    // -------------------------------------------------------------------

    if (submitBtn) {
        submitBtn.addEventListener('click', () => {
            // 1. Get the value from localStorage
            const savedButtonId = localStorage.getItem(STORAGE_KEY);
            
            // 2. Determine the console message
            let consoleMessage = "MultiButtonXAPPA";

            // 3. Reset (hide) all content containers before showing the selected one
            hideAllContent();

            // 4. Check the ID and perform actions (console log and class removal)
            if (savedButtonId === 'perroButton0001') {
                consoleMessage = "MultiButtonXPerro";
                if (perroContent) {
                    perroContent.classList.remove(HIDDEN_CLASS);
                }
            } else if (savedButtonId === 'gatoButton0001') {
                consoleMessage = "MultiButtonXGato";
                if (gatoContent) {
                    gatoContent.classList.remove(HIDDEN_CLASS);
                }
            }
            
            // 5. Log the required information to the console
            console.log(savedButtonId);
            console.log(consoleMessage);
        });
    } else {
        console.warn("Element with ID 'submitBtn' not found.");
    }
});








// --- Code to hide the add popup button when submit button is clicked ---


// Get a reference to the hide button
const submitButton = document.getElementById('submitBtn');

// Get a reference to the div
const divToHide = document.querySelector('.button-container852');

// Add an event listener to hide the div on click
submitButton.addEventListener('click', function() {
  divToHide.style.display = 'none';





  setTimeout(() => {
    // Get icon references (assumes they exist in DOM)
    const dogIcon = document.getElementById('dog-icon');
    const catIcon = document.getElementById('cat-icon');
    

     const dogIconx = document.getElementById('dogsy');
    const catIconx = document.getElementById('catsy');

    // Check localStorage value
    const petType = localStorage.getItem('Extra Pet Type');




   const extraIconSpan = document.querySelector('.extraicons');
    if (extraIconSpan) {
       
        const iconElement = extraIconSpan.querySelector('i');

        // Check if the icon element exists
        if (iconElement) {
            // Remove existing icon classes (fas and fa-*)
            iconElement.classList.remove('fa-cat', 'fa-dog');

            // Add the new icon class based on the pet type
            if (petType === 'PERRO') {
                iconElement.classList.add('fa-dog');
                console.log('Pet icon changed to dog.');
            } else if (petType === 'GATO') {
                iconElement.classList.add('fa-cat');
                console.log('Pet icon changed to cat.');
            } else {
                // Default case if no valid pet type is found
                iconElement.classList.add('fa-cat'); // Or any other default
                console.log('No valid pet type found, defaulting to cat icon.');
            }
        } else {
            console.error('Icon element <i> not found within .extraicons.');
        }
    } else {
        console.error('Span with class "extraicons" not found.');
    }




    if (petType === 'GATO') {
  dogIconx.classList.add('hidden');
        catIconx.classList.remove('hidden');
        
        dogIcon.classList.add('hidden');
        catIcon.classList.remove('hidden');
    } else if (petType === 'PERRO') {
          catIconx.classList.add('hidden');
        dogIconx.classList.remove('hidden');

        catIcon.classList.add('hidden');
        dogIcon.classList.remove('hidden');
    }
}, 1000);



  
});

// --- Code to show the div ---
// Get a reference to the show button
const showButton = document.querySelector('.perroextra');

// Get a reference to the div (same div as above)
const divToShow = document.querySelector('.button-container852');

// Add an event listener to show the div on click
showButton.addEventListener('click', function() {
  divToShow.style.display = 'block';
});












// Show the xtra pet div based on selection

// Right button click handler
document.querySelectorAll('.right-button987').forEach(button => {
    button.addEventListener('click', () => {
        // Add hidden0x0 to .showme div
        document.querySelector('.showme')?.classList.add('hidden0x0');
        
        // Remove hidden0x0 from #extrapetdiv
        document.getElementById('extrapetdiv')?.classList.remove('hidden0x0');
        
        // Console log current state
        console.log({
            showmeHidden: document.querySelector('.showme')?.classList.contains('hidden0x0'),
            extrapetVisible: !document.getElementById('extrapetdiv')?.classList.contains('hidden0x0'),
            showmeElement: document.querySelector('.showme'),
            extrapetElement: document.getElementById('extrapetdiv')
        });
    });
});

// Left button click handler
document.querySelectorAll('.left-button987').forEach(button => {
    button.addEventListener('click', () => {
        // Remove hidden0x0 from .showme div
        document.querySelector('.showme')?.classList.remove('hidden0x0');
        
        // Add hidden0x0 to #extrapetdiv
        document.getElementById('extrapetdiv')?.classList.add('hidden0x0');
        
        // Console log current state
        console.log({
            showmeHidden: document.querySelector('.showme')?.classList.contains('hidden0x0'),
            extrapetVisible: !document.getElementById('extrapetdiv')?.classList.contains('hidden0x0'),
            showmeElement: document.querySelector('.showme'),
            extrapetElement: document.getElementById('extrapetdiv')
        });
    });
});








// Two Only- Update subtotal on the change of top and right span
// Run when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceWatchers);
} else {
    initPriceWatchers();
}

function initPriceWatchers() {
    let perroObserver = null;
    let gatoObserver = null;

    function updatePerroTotal() {
        if (localStorage.getItem('activeButtonId') !== 'perroButton0001') return;

        const fixedSpan = document.querySelector('span.product-price-fixed');
        const maxSpan = document.querySelector('span.perropricemax');
        const totalSpan = document.querySelector('span.product-price-fixed-total');
        if (!fixedSpan || !totalSpan) return;

        const parse = str => {
            if (!str || str === 'none') return 0;
            const n = parseFloat(str.replace(/[^0-9.-]/g, ''));
            return isNaN(n) ? 0 : n;
        };

        const fixed = parse(fixedSpan.textContent.trim());
        const max = parse(maxSpan ? maxSpan.textContent.trim() : '');
        const total = fixed + max;

        totalSpan.textContent = total.toFixed(2);
        localStorage.setItem('Perro Maxtotal Value', total.toString());

        console.log({
            'product-price-fixed': fixed,
            'perropricemax': max,
            'Calculation': `${fixed} + ${max} = ${total}`,
            'Total': total,
            'Active Button ID': 'perroButton0001',
            'Saved to LocalStorage': 'Perro Maxtotal Value'
        });
    }

    function updateGatoTotal() {
        if (localStorage.getItem('activeButtonId') !== 'gatoButton0001') return;

        const fixedSpan = document.querySelector('span.product-price-fixed-cat');
        const maxSpan = document.querySelector('span.gatopricemax');
        const totalSpan = document.querySelector('span.product-price-fixed-cat-total');
        if (!fixedSpan || !totalSpan) return;

        const parse = str => {
            if (!str || str === 'none') return 0;
            const n = parseFloat(str.replace(/[^0-9.-]/g, ''));
            return isNaN(n) ? 0 : n;
        };

        const fixed = parse(fixedSpan.textContent.trim());
        const max = parse(maxSpan ? maxSpan.textContent.trim() : '');
        const total = fixed + max;

        totalSpan.textContent = total.toFixed(2);
        localStorage.setItem('Gato Maxtotal Value', total.toString());

        console.log({
            'product-price-fixed-cat': fixed,
            'gatopricemax': max,
            'Calculation': `${fixed} + ${max} = ${total}`,
            'Total': total,
            'Active Button ID': 'gatoButton0001',
            'Saved to LocalStorage': 'Gato Maxtotal Value'
        });
    }

    // Clean up old observers if re-initialized
    if (perroObserver) perroObserver.disconnect();
    if (gatoObserver) gatoObserver.disconnect();

    // === PERRO SETUP ===
    const perroFixed = document.querySelector('span.product-price-fixed');
    const perroMax = document.querySelector('span.perropricemax');
    if (perroFixed) {
        perroObserver = new MutationObserver(updatePerroTotal);
        perroObserver.observe(perroFixed, { childList: true, subtree: true, characterData: true });
        if (perroMax) {
            perroObserver.observe(perroMax, { childList: true, subtree: true, characterData: true });
        }
        // Run once
        updatePerroTotal();
    }

    // === GATO SETUP ===
    const gatoFixed = document.querySelector('span.product-price-fixed-cat');
    const gatoMax = document.querySelector('span.gatopricemax');
    if (gatoFixed) {
        gatoObserver = new MutationObserver(updateGatoTotal);
        gatoObserver.observe(gatoFixed, { childList: true, subtree: true, characterData: true });
        if (gatoMax) {
            gatoObserver.observe(gatoMax, { childList: true, subtree: true, characterData: true });
        }
        // Run once
        updateGatoTotal();
    }
}









document.addEventListener('DOMContentLoaded', function() {
  const submitBtn = document.getElementById('submitBtn');

  if (submitBtn) {
    submitBtn.addEventListener('click', function() {
      // Get Pet Extra Price from localStorage
      const petExtraPrice = localStorage.getItem('Pet Extra Price');

      if (petExtraPrice !== null) {
        // Update the spans
        const gatoSpan = document.querySelector('.gatopricemax');
        const perroSpan = document.querySelector('.perropricemax');

        if (gatoSpan) gatoSpan.textContent = petExtraPrice;
        if (perroSpan) perroSpan.textContent = petExtraPrice;

        console.log('Pet Extra Price updated to:', petExtraPrice);
      } else {
        console.warn('Pet Extra Price not found in localStorage.');
      }
    });
  }
});






document.addEventListener('DOMContentLoaded', function() {
let isRunning = false;

function calculateAndDisplayBagExtra() {
    if (isRunning) return;
    isRunning = true;

    try {
        const activeButton = localStorage.getItem('activeButtonId');
        const extraPetType = localStorage.getItem('Extra Pet Type'); // "PERRO" or "GATO"
        const dogPlanPrice = parseFloat(localStorage.getItem('Dog Plan Price')) || 1;
        const catPlanPrice = parseFloat(localStorage.getItem('Cat Plan Price')) || 1;

        let sourceValue = 0;
        let mode = '';
        let sourceSpan = null;

        if (activeButton === 'perroButton0001') {
            sourceSpan = document.querySelector('span.perropricemax');
            mode = 'Perro';
        } else if (activeButton === 'gatoButton0001') {
            sourceSpan = document.querySelector('span.gatopricemax');
            mode = 'Gato';
        } else {
            return;
        }

        if (!sourceSpan) return;

        const text = sourceSpan.textContent.trim();
        sourceValue = (text && text !== 'none')
            ? parseFloat(text.replace(/[^0-9.-]/g, '')) || 0
            : 0;

        const divisor = extraPetType === 'GATO' ? catPlanPrice : dogPlanPrice;
        const rawResult = sourceValue / divisor;
        const roundedResult = Math.round(rawResult);

        const petTypeLabel = extraPetType === 'GATO' ? 'Gato' : 'Perro';
        const storageKey = `${mode} ${petTypeLabel} Extra Bag`;

        localStorage.setItem(storageKey, roundedResult.toString());

        let displayInfo = {};

        if (storageKey === 'Perro Perro Extra Bag') {
            const bagsSpan = document.querySelector('span.bagsToSend');
            if (bagsSpan) {
                const baseBags = parseInt(bagsSpan.textContent.trim()) || 0;
                bagsSpan.textContent = baseBags + roundedResult;
                displayInfo = { action: 'Updated Perro total bags', baseBags, extraBags: roundedResult, totalBags: baseBags + roundedResult };
            }
        } else if (storageKey === 'Gato Gato Extra Bag') {
            const bagsSpan = document.querySelector('span.bagsToSend-cat');
            if (bagsSpan) {
                const baseBags = parseInt(bagsSpan.textContent.trim()) || 0;
                bagsSpan.textContent = baseBags + roundedResult;
                displayInfo = { action: 'Updated Gato total bags', baseBags, extraBags: roundedResult, totalBags: baseBags + roundedResult };
            }
        } else if (storageKey === 'Perro Gato Extra Bag') {
            // ✅ NOW updates extrabagsspanx (not extrabagsspan)
            const extraSpan = document.querySelector('span.extrabagsspanx');
            if (extraSpan) {
                const text = roundedResult > 0 ? `+ ${roundedResult} paquetes de 200gr` : '';
                extraSpan.textContent = text;
                displayInfo = { action: 'Updated cross extra bags (Perro→Gato)', extraBags: roundedResult, displayText: text };
            }
        } else if (storageKey === 'Gato Perro Extra Bag') {
            // ✅ Still uses extrabagsspan (unchanged)
            const extraSpan = document.querySelector('span.extrabagsspan');
            if (extraSpan) {
                const text = roundedResult > 0 ? `+ ${roundedResult} paquetes de 500gr` : '';
                extraSpan.textContent = text;
                displayInfo = { action: 'Updated cross extra bags (Gato→Perro)', extraBags: roundedResult, displayText: text };
            }
        }

        console.log({
            'Active Button': activeButton,
            'Extra Pet Type': extraPetType,
            'Source Value': sourceValue,
            'Divisor Used': divisor,
            'Raw Result': rawResult,
            'Rounded Result (Full Number)': roundedResult,
            'Storage Key': storageKey,
            'Display Action': displayInfo
        });
    } finally {
        isRunning = false;
    }
}

// Run once on load
document.addEventListener('DOMContentLoaded', calculateAndDisplayBagExtra);

// Only observe input spans to avoid infinite loops
const perroSpan = document.querySelector('span.perropricemax');
const gatoSpan = document.querySelector('span.gatopricemax');

if (perroSpan || gatoSpan) {
    const observer = new MutationObserver(calculateAndDisplayBagExtra);
    const config = { childList: true, characterData: true, subtree: true };
    if (perroSpan) observer.observe(perroSpan, config);
    if (gatoSpan) observer.observe(gatoSpan, config);
}
});









function simulateLeftButtonClick() {
    setTimeout(() => {
        const activeButtonId = localStorage.getItem('activeButtonId');
        
        let leftButtonSelector = '';
        if (activeButtonId === 'perroButton0001') {
            leftButtonSelector = '.left8521';
        } else if (activeButtonId === 'gatoButton0001') {
            leftButtonSelector = '.left852';
        } else {
            console.log('No valid active button for left click simulation');
            return;
        }

        const leftButton = document.querySelector(leftButtonSelector);
        if (!leftButton) {
            console.warn('Left button not found. Retrying...');
            setTimeout(simulateLeftButtonClick, 50);
            return;
        }

        if (leftButton.offsetParent === null) {
            console.warn('Left button not visible. Retrying...');
            setTimeout(simulateLeftButtonClick, 50);
            return;
        }

        const event = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
            buttons: 1
        });
        leftButton.dispatchEvent(event);

        console.log('Simulated left button click dispatched ✅');
    }, 1000);
}



function removeAppaButton(event) {


// Call this instead of activateLeftView()
simulateLeftButtonClick();


    function updateTotalPrice() {
        // --- 1. Collect Common Value ---
        const petExtraPriceString = localStorage.getItem('Pet Extra Price');
        const petExtraPrice = parseFloat(petExtraPriceString) || 0;

        // ------------------------------------------------------------------
        // --- CALCULATION AND UPDATE FOR DOG (Perro) ---
        // ------------------------------------------------------------------

        // 1. Collect 'Perro Maxtotal Value'
        const perroMaxTotalValueString = localStorage.getItem('Perro Maxtotal Value');

        // 2. Convert to number
        const perroMaxTotalValue = parseFloat(perroMaxTotalValueString) || 0;

        // 3. Perform subtraction
        const perroNewTotalValue = perroMaxTotalValue - petExtraPrice;

        // 4. Format the result
        const perroFormattedTotal = perroNewTotalValue.toFixed(2);

        // 5. Find and update the dog target span
        const perroTargetSpan = document.querySelector('span.product-price-fixed-total');

        if (perroTargetSpan) {
            perroTargetSpan.textContent = perroFormattedTotal;
        } else {
            console.error('Target span with class "product-price-fixed-total" (Perro) not found.');
        }

        // ------------------------------------------------------------------
        // --- CALCULATION AND UPDATE FOR CAT (Gato) ---
        // ------------------------------------------------------------------

        // 1. Collect 'Gato Maxtotal Value'
        const gatoMaxTotalValueString = localStorage.getItem('Gato Maxtotal Value');

        // 2. Convert to number
        const gatoMaxTotalValue = parseFloat(gatoMaxTotalValueString) || 0;

        // 3. Perform subtraction
        const gatoNewTotalValue = gatoMaxTotalValue - petExtraPrice;

        // 4. Format the result
        const gatoFormattedTotal = gatoNewTotalValue.toFixed(2);

        // 5. Find and update the cat target span
        // Assuming the Cat's target span is 'product-price-fixed-cat-total'
        const gatoTargetSpan = document.querySelector('span.product-price-fixed-cat-total'); 

        if (gatoTargetSpan) {
            gatoTargetSpan.textContent = gatoFormattedTotal;
        } else {
            console.warn('Target span with class "product-price-fixed-cat-total" (Gato) not found.');
        }
    }

    // Execute the update function once the document is fully loaded
    updateTotalPrice();





 localStorage.removeItem("Perro Gato Extra Bag");

 localStorage.removeItem("Perro Perro Extra Bag");

 localStorage.removeItem("Gato Gato Extra Bag");

 localStorage.removeItem("Gato Perro Extra Bag");










      setTimeout(() => {
 const activeButton = localStorage.getItem('activeButtonId');

// Clean right buttons (by ID - most reliable)
['appaBtn', 'gatoBtn'].forEach(id => {
    const btn = document.getElementById(id);
    if (btn) btn.classList.remove('selected-btn');
});

// Hide right container
const rightBtnContainer = document.querySelector('.right-button987');
if (rightBtnContainer) {
    rightBtnContainer.classList.add('d-none');
}

// Hide pet sections
if (activeButton === 'perroButton0001') {
    document.querySelector('.perroxp')?.classList.add('d-none');
} else if (activeButton === 'gatoButton0001') {
    document.querySelector('.gatooxp')?.classList.add('d-none');
}

// ✅ FORCE SELECT ALL LEFT BUTTONS (as requested)
const leftButtons = document.querySelectorAll('.left-button987');
console.log('Found left buttons:', leftButtons.length); // 🔍 DEBUG

leftButtons.forEach((btn, index) => {
    btn.classList.add('selected-btn');
    console.log(`✅ Added 'selected-btn' to left button ${index + 1}`, btn);
});

// Trigger UI logic
if (leftButtons.length > 0) {
    document.querySelector('.showme')?.classList.remove('hidden0x0');
    document.getElementById('extrapetdiv')?.classList.add('hidden0x0');
    console.log('✅ Left-button logic triggered');
}

    // Clean up extra bag data
    ['Perro Perro Extra Bag', 'Perro Gato Extra Bag', 'Gato Gato Extra Bag', 'Gato Perro Extra Bag']
        .forEach(key => localStorage.removeItem(key));
         }, 500); // 500 milliseconds = 0.5 seconds











          // 1. Reset bag totals
    const perroPerro = parseInt(localStorage.getItem('Perro Perro Extra Bag')) || 0;
    const gatoGato = parseInt(localStorage.getItem('Gato Gato Extra Bag')) || 0;

    const bagsToSend = document.querySelector('span.bagsToSend');
    if (bagsToSend && perroPerro > 0) {
        const current = parseInt(bagsToSend.textContent.trim()) || 0;
        bagsToSend.textContent = Math.max(0, current - perroPerro);
    }

    const bagsToSendCat = document.querySelector('span.bagsToSend-cat');
    if (bagsToSendCat && gatoGato > 0) {
        const current = parseInt(bagsToSendCat.textContent.trim()) || 0;
        bagsToSendCat.textContent = Math.max(0, current - gatoGato);
    }

    // 2. Clear extra spans
    const span1 = document.querySelector('span.extrabagsspan');
    const span2 = document.querySelector('span.extrabagsspanx');
    if (span1) span1.textContent = '';
    if (span2) span2.textContent = '';

    // 3. Clean localStorage
    ['Perro Perro Extra Bag', 'Perro Gato Extra Bag', 'Gato Gato Extra Bag', 'Gato Perro Extra Bag']
        .forEach(key => localStorage.removeItem(key));







              // 1. Use querySelectorAll to find ALL elements with the class 'button-container852'.
            const targetDivs = document.querySelectorAll('.button-container852');
            
            // 2. Iterate over the found elements
            targetDivs.forEach(div => {
                // 3. Check if the element is currently hidden via its inline style
                // This correctly targets the two hidden divs.
                if (div.style.display === 'none') {
                    // 4. Change the inline style to make it visible
                    div.style.display = 'block';
                }
            });
            
            // OPTIONAL: Update the button text after the action
            document.getElementById('toggleButton').textContent = 'Content Revealed!';









            





    
}














function updateFrequency() {
    const active = localStorage.getItem('activeButtonId');
    const target = document.querySelector('.frequency-option-extra');
    if (!target) return;

    let source;
    if (active === 'perroButton0001') {
        source = document.querySelector('.frequency-option');
    } else if (active === 'gatoButton0001') {
        source = document.querySelector('.cat-frequency-option');
    }

    target.textContent = source ? source.textContent.trim() : '';
}

// Run once at start
document.addEventListener('DOMContentLoaded', updateFrequency);

// Watch for changes in either source span
const perroSpan = document.querySelector('.frequency-option');
const gatoSpan = document.querySelector('.cat-frequency-option');

if (perroSpan || gatoSpan) {
    const observer = new MutationObserver(updateFrequency);
    if (perroSpan) observer.observe(perroSpan, { childList: true, subtree: true, characterData: true });
    if (gatoSpan) observer.observe(gatoSpan, { childList: true, subtree: true, characterData: true });
}
















  // Set a timeout to delay the execution of the collection and removal by 2 seconds
  setTimeout(function() {
    
    // === Gato Maxtotal Value ===
    const gatoValue = localStorage.getItem("Gato Maxtotal Value");
    localStorage.removeItem("Gato Maxtotal Value");

    // === Perro Maxtotal Value ===
    const perroValue = localStorage.getItem("Perro Maxtotal Value");
    localStorage.removeItem("Perro Maxtotal Value");

    // === Pet Extra Price ===
    const petExtraPriceValue = localStorage.getItem("Pet Extra Price");
    localStorage.removeItem("Pet Extra Price");
    
    // --- Console Log Summary (Optional) ---
    console.log("2-second delay complete. LocalStorage removal summary:");
    
    // Helper function to log status
    const logStatus = (key, value) => {
        if (value !== null) {
            console.log(`- '${key}' collected: "${value}" and removed.`);
        } else {
            console.log(`- '${key}' was not found.`);
        }
    };

    logStatus("Gato Maxtotal Value", gatoValue);
    logStatus("Perro Maxtotal Value", perroValue);
    logStatus("Pet Extra Price", petExtraPriceValue);

  }, 2000); // 2000 milliseconds = 2 seconds

















// =============== PART 1: DOM Mutation Observer ===============

// Function to run when activation is triggered
function runActivationLogic() {










// Get values
const extraPetType = localStorage.getItem('Extra Pet Type');
const extraPetFrequency = parseInt(localStorage.getItem('Extra Pet Frequency')?.match(/\d+/)?.[0] || 0, 10);
const catPlanPrice = parseFloat(localStorage.getItem('Cat Plan Price')) || 0;
const catPlanQuantity = parseFloat(localStorage.getItem('Cat Plan Quantity')) || 0;
const dogPlanPrice = parseFloat(localStorage.getItem('Dog Plan Price')) || 0;
const dogPlanQuantity = parseFloat(localStorage.getItem('Dog Plan Quantity')) || 0;

// Get span value (assuming first .gramos-value-extra contains the numeric span value)
const spanElement = document.querySelector('.gramos-value-extra');
let spanValue = 0;
if (spanElement) {
    const text = spanElement.textContent || spanElement.innerText || '';
    const match = text.match(/[\d.]+/);
    spanValue = match ? parseFloat(match[0]) : 0;
}

// Helper to round 1.2→2, 4.9→5 etc. (ceiling at .1+)
function smartRound(num) {
    return Math.floor(num) + (num % 1 > 0.1 ? 1 : 0);
}
// Helper to round to 2 decimal places
function toFixed2(num) {
    return Math.round(num * 100) / 100;
}

// ... [previous calculation code] ...
const activeButtonId = localStorage.getItem('activeButtonId');

if (extraPetType === 'PERRO') {
    const baseValue = (spanValue * (extraPetFrequency * 7)) / dogPlanQuantity;
    const roundedBase = smartRound(baseValue);
    let perropricemax = roundedBase * dogPlanPrice;
    perropricemax = toFixed2(perropricemax);
    console.log(`PERRO calculation: (${spanValue} * (${extraPetFrequency} * 7)) / ${dogPlanQuantity} = ${baseValue} → rounded to ${roundedBase} → * ${dogPlanPrice} = ${perropricemax}`);
    
    if (localStorage.getItem('Perro Perro Extra Bag') !== null) {
        localStorage.setItem('Perro Perro Extra Bag', roundedBase.toString());
    }
    if (localStorage.getItem('Gato Perro Extra Bag') !== null) {
        localStorage.setItem('Gato Perro Extra Bag', roundedBase.toString());
    }
    
    localStorage.setItem('Pet Extra Price', perropricemax.toString());
    
    // Update span based on activeButtonId
    if (activeButtonId === 'perroButton0001') {
        const perroSpan = document.querySelector('span.perropricemax');
        if (perroSpan) perroSpan.textContent = perropricemax;
    } else if (activeButtonId === 'gatoButton0001') {
        const gatoSpan = document.querySelector('span.gatopricemax');
        if (gatoSpan) gatoSpan.textContent = perropricemax;
    }

} else if (extraPetType === 'GATO') {
    const baseValue = (spanValue * (extraPetFrequency * 7)) / catPlanQuantity;
    const roundedBase = smartRound(baseValue);
    let gatopricemax = roundedBase * catPlanPrice;
    gatopricemax = toFixed2(gatopricemax);
    console.log(`GATO calculation: (${spanValue} * (${extraPetFrequency} * 7)) / ${catPlanQuantity} = ${baseValue} → rounded to ${roundedBase} → * ${catPlanPrice} = ${gatopricemax}`);
    
    if (localStorage.getItem('Perro Gato Extra Bag') !== null) {
        localStorage.setItem('Perro Gato Extra Bag', roundedBase.toString());
    }
    if (localStorage.getItem('Gato Gato Extra Bag') !== null) {
        localStorage.setItem('Gato Gato Extra Bag', roundedBase.toString());
    }
    
    localStorage.setItem('Pet Extra Price', gatopricemax.toString());
    
    // Update span based on activeButtonId
    if (activeButtonId === 'gatoButton0001') {
        const gatoSpan = document.querySelector('span.gatopricemax');
        if (gatoSpan) gatoSpan.textContent = gatopricemax;  // ✅ gatopricemax, not perropricemax
    } else if (activeButtonId === 'perroButton0001') {
        const perroSpan = document.querySelector('span.perropricemax');
        if (perroSpan) perroSpan.textContent = gatopricemax;  // ✅ gatopricemax, not perropricemax
    }
}


// Handle activeButtonId logic separately

const petExtraPrice = parseFloat(localStorage.getItem('Pet Extra Price')) || 0;

if (activeButtonId === 'perroButton0001') {
    const fixedPriceSpan = document.querySelector('span.product-price-fixed');
    const fixedPrice = fixedPriceSpan ? parseFloat(fixedPriceSpan.textContent.replace(/[^\d.-]/g, '')) : 0;
    const perroMaxTotal = toFixed2(fixedPrice + petExtraPrice);
    
    localStorage.setItem('Perro Maxtotal Value', perroMaxTotal.toString());
    
    const totalSpan = document.querySelector('span.product-price-fixed-total');
    if (totalSpan) totalSpan.textContent = perroMaxTotal;
    
    console.log('Perro Maxtotal Value:', perroMaxTotal);
    
} else if (activeButtonId === 'gatoButton0001') {
    const fixedPriceSpan = document.querySelector('span.product-price-fixed-cat');
    const fixedPrice = fixedPriceSpan ? parseFloat(fixedPriceSpan.textContent.replace(/[^\d.-]/g, '')) : 0;
    const gatoMaxTotal = toFixed2(fixedPrice + petExtraPrice);
    
    localStorage.setItem('Gato Maxtotal Value', gatoMaxTotal.toString());
    
    const totalSpan = document.querySelector('span.product-price-fixed-cat-total');
    if (totalSpan) totalSpan.textContent = gatoMaxTotal;
    
    console.log('Gato Maxtotal Value:', gatoMaxTotal);
}






    
}

// Set up observer for a single .gramos-value-extra element
function setupObserverForElement(element) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'characterData' || 
                mutation.type === 'childList' || 
                (mutation.type === 'attributes' && mutation.attributeName !== 'class')) {
                runActivationLogic();
            }
        });
    });

    observer.observe(element, {
        characterData: true,
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value', 'data-value', 'style']
    });
}

// Observe existing elements
const targetElements = document.querySelectorAll('.gramos-value-extra');
targetElements.forEach(setupObserverForElement);

// Observe future elements added to DOM
const documentObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.classList.contains('gramos-value-extra')) {
                    setupObserverForElement(node);
                }
                node.querySelectorAll('.gramos-value-extra').forEach(setupObserverForElement);
            }
        });
    });
});

documentObserver.observe(document.body, {
    childList: true,
    subtree: true
});

// =============== PART 2: localStorage Change Listener ===============

// Override setItem to detect same-tab changes
const originalSetItem = Storage.prototype.setItem;
Storage.prototype.setItem = function(key, value) {
    const oldValue = this.getItem(key);
    const event = new Event('localStorageSet');
    event.key = key;
    event.newValue = value;
    event.oldValue = oldValue;
    window.dispatchEvent(event);
    originalSetItem.apply(this, arguments);
};

// Handle localStorage changes
function handleStorageChange(key) {
    if (key === 'Extra Pet Frequency') {
        runActivationLogic();
    }
}

// Cross-tab changes
window.addEventListener('storage', (e) => {
    if (e.key === 'Extra Pet Frequency') {
        handleStorageChange(e.key);
    }
});

// Same-tab changes
window.addEventListener('localStorageSet', (e) => {
    if (e.key === 'Extra Pet Frequency') {
        handleStorageChange(e.key);
    }
});
















//collect the needed spans value for recommended perro gato and extra in localstorage


document.addEventListener('click', function(e) {
    if (e.target.classList.contains('btn-submit963')) {
        setTimeout(() => {
            const activeButtonId = localStorage.getItem('activeButtonId');
            
            if (activeButtonId === 'perroButton0001') {
                const gramsNeeded = document.querySelector('span.grams-needed')?.textContent?.trim() || '';
                const pricePerDay = document.querySelector('span.price-per-day')?.textContent?.trim() || '';
                const discountedPrice = document.querySelector('span.price-per-day-discounted-extra')?.textContent?.trim() || '';
                
                const gramosText = document.querySelector('span.gramos-value-extra')?.textContent?.trim() || '';
const gramosValue = gramosText.match(/\d+(\.\d+)?/)?.[0] || '0';
                
                localStorage.setItem('Old gram need perro', gramsNeeded);
                localStorage.setItem('Old price need perro', pricePerDay);
                localStorage.setItem('New price need Extra', discountedPrice);
                localStorage.setItem('New gram need Extra', gramosValue);
                
            } else if (activeButtonId === 'gatoButton0001') {
                const gramsNeededCat = document.querySelector('span.grams-needed-cat')?.textContent?.trim() || '';
                const pricePerDayCat = document.querySelector('span.price-per-day-cat')?.textContent?.trim() || '';
                const discountedPrice = document.querySelector('span.price-per-day-discounted-extra')?.textContent?.trim() || '';
                const gramosText = document.querySelector('span.gramos-value-extra')?.textContent?.trim() || '';
const gramosValue = gramosText.match(/\d+(\.\d+)?/)?.[0] || '0';
                
                localStorage.setItem('Old gram need gato', gramsNeededCat);
                localStorage.setItem('Old price need gato', pricePerDayCat);
                localStorage.setItem('New price need Extra', discountedPrice);
                localStorage.setItem('New gram need Extra', gramosValue);
            }
        }, 2000);
    }
});






// Update the spans with the new needed value plus hide and show for recommended value
document.addEventListener('click', function(e) {
    const activeButtonId = localStorage.getItem('activeButtonId');
    
    // PERRO logic
    if (activeButtonId === 'perroButton0001') {
        if (e.target.closest('.perroxp')) {
            // Hide original, show extra
            document.querySelector('span.grams-needed')?.classList.add('hidden');
            document.querySelector('span.price-per-day')?.classList.add('hidden');
            document.querySelector('span.dog-name')?.classList.add('hidden');

            const extraGrams = document.querySelector('span.extra-grams-needed');
            const extraPrice = document.querySelector('span.extra-price-per-day');
            const extraName = document.querySelector('span.extra-pet-name');

            if (extraGrams) {
                extraGrams.textContent = localStorage.getItem('New gram need Extra') || '';
                extraGrams.classList.remove('hidden');
            }
            if (extraPrice) {
                extraPrice.textContent = localStorage.getItem('New price need Extra') || '';
                extraPrice.classList.remove('hidden');
            }
            if (extraName) {
                extraName.textContent = localStorage.getItem('Extra Pet Pet Name') || '';
                extraName.classList.remove('hidden');
            }

        } else if (e.target.closest('.left-button987')) {
            // Show original, hide extra
            document.querySelector('span.grams-needed')?.classList.remove('hidden');
            document.querySelector('span.price-per-day')?.classList.remove('hidden');
            document.querySelector('span.dog-name')?.classList.remove('hidden');

            document.querySelector('span.extra-grams-needed')?.classList.add('hidden');
            document.querySelector('span.extra-price-per-day')?.classList.add('hidden');
            document.querySelector('span.extra-pet-name')?.classList.add('hidden');
        }
    }
    // GATO logic
    else if (activeButtonId === 'gatoButton0001') {
        if (e.target.closest('.gatoxp')) {
            // Hide original, show extra
            document.querySelector('span.grams-needed-cat')?.classList.add('hidden');
            document.querySelector('span.price-per-day-cat')?.classList.add('hidden');
            document.querySelector('span.firstcat')?.classList.add('hidden');

            const extraGramsCat = document.querySelector('span.extra-grams-needed-cat');
            const extraPriceCat = document.querySelector('span.extra-price-per-day-cat');
            const extraName = document.querySelector('span.extra-cat-name');

            if (extraGramsCat) {
                extraGramsCat.textContent = localStorage.getItem('New gram need Extra') || '';
                extraGramsCat.classList.remove('hidden');
            }
            if (extraPriceCat) {
                extraPriceCat.textContent = localStorage.getItem('New price need Extra') || '';
                extraPriceCat.classList.remove('hidden');
            }
            if (extraName) {
                extraName.textContent = localStorage.getItem('Extra Pet Pet Name') || '';
                extraName.classList.remove('hidden');
            }

        } else if (e.target.closest('.left-button987')) {
            // Show original, hide extra
            document.querySelector('span.grams-needed-cat')?.classList.remove('hidden');
            document.querySelector('span.price-per-day-cat')?.classList.remove('hidden');
            document.querySelector('span.firstcat')?.classList.remove('hidden');

            document.querySelector('span.extra-grams-needed-cat')?.classList.add('hidden');
            document.querySelector('span.extra-price-per-day-cat')?.classList.add('hidden');
            document.querySelector('span.extra-cat-name')?.classList.add('hidden');
        }
    }
});




document.addEventListener('DOMContentLoaded', () => {
    const logRed = (...args) => console.log('%c' + args.join(' '), 'color: red; font-weight: bold;');

    // Preserve original setItem
    const originalSetItem = localStorage.setItem;

    let currentActiveId = null;
    let currentObserver = null;

    const safeParse = (value) => {
        const num = parseFloat(value);
        return isNaN(num) ? 0 : num;
    };

    const runBagCalculation = (activeButtonId) => {
        // Clean up previous observer
        if (currentObserver) {
            currentObserver.disconnect();
            currentObserver = null;
        }

        // 🔹 DOG: update .bagsToSend
        if (activeButtonId === 'perroButton0001') {
            const totalSpan = document.querySelector('.product-price-fixed-total');
            const basePriceSpan = document.querySelector('.product-price-fixed');
            const targetSpan = document.querySelector('.bagsToSend');

            if (!totalSpan || !basePriceSpan) {
                logRed('❌ Missing dog price spans.');
                return;
            }

            const updateDogBags = () => {
                const basePrice = safeParse(basePriceSpan.textContent.replace(/[^\d.-]/g, ''));
                const dogPlanPrice = safeParse(localStorage.getItem('Dog Plan Price'));
                if (dogPlanPrice <= 0) {
                    logRed('Dog Plan Price invalid.');
                    return;
                }

                const originalBags = basePrice / dogPlanPrice;
                const perroPerroExtra = localStorage.getItem('Perro Perro Extra Bag');
                const extraBags = perroPerroExtra !== null ? safeParse(perroPerroExtra) : 0;
                const totalPlusedBags = originalBags + extraBags;

                localStorage.setItem('Perro Original Bags', originalBags.toFixed(4));
                localStorage.setItem('Perro Total Plused Bags', totalPlusedBags.toFixed(4));

                if (targetSpan) {
                    targetSpan.textContent = Math.round(totalPlusedBags).toString();
                }

                logRed(
                    `🐶 DOG BAGS → Original: ${originalBags.toFixed(2)}, ` +
                    `Extra: ${extraBags.toFixed(2)} (${perroPerroExtra ? 'PerroPerro' : 'none'}), ` +
                    `Total: ${totalPlusedBags.toFixed(2)} → UI: ${Math.round(totalPlusedBags)}`
                );
            };

            currentObserver = new MutationObserver(updateDogBags);
            currentObserver.observe(totalSpan, { childList: true, subtree: true, characterData: true });
            updateDogBags();

        // 🔸 CAT: update .bagsToSend-cat
        } else if (activeButtonId === 'gatoButton0001') {
            const totalSpan = document.querySelector('.product-price-fixed-cat-total');
            const basePriceSpan = document.querySelector('.product-price-fixed-cat');
            const targetSpan = document.querySelector('.bagsToSend-cat'); // ← CHANGED

            if (!totalSpan || !basePriceSpan) {
                logRed('❌ Missing cat price spans.');
                return;
            }

            const updateCatBags = () => {
                const basePrice = safeParse(basePriceSpan.textContent.replace(/[^\d.-]/g, ''));
                const catPlanPrice = safeParse(localStorage.getItem('Cat Plan Price'));
                if (catPlanPrice <= 0) {
                    logRed('Cat Plan Price invalid.');
                    return;
                }

                const originalBags = basePrice / catPlanPrice;
                const gatoGatoExtra = localStorage.getItem('Gato Gato Extra Bag');
                const extraBags = gatoGatoExtra !== null ? safeParse(gatoGatoExtra) : 0;
                const totalPlusedBags = originalBags + extraBags;

                localStorage.setItem('Gato Original Bags', originalBags.toFixed(4));
                localStorage.setItem('Gato Total Plused Bags', totalPlusedBags.toFixed(4));

                if (targetSpan) {
                    targetSpan.textContent = Math.round(totalPlusedBags).toString();
                }

                logRed(
                    `🐱 CAT BAGS → Original: ${originalBags.toFixed(2)}, ` +
                    `Extra: ${extraBags.toFixed(2)} (${gatoGatoExtra ? 'GatoGato' : 'none'}), ` +
                    `Total: ${totalPlusedBags.toFixed(2)} → UI: ${Math.round(totalPlusedBags)}`
                );
            };

            currentObserver = new MutationObserver(updateCatBags);
            currentObserver.observe(totalSpan, { childList: true, subtree: true, characterData: true });
            updateCatBags();
        }
    };

    // 🔁 Watch localStorage['activeButtonId']
    localStorage.setItem = function(key, value) {
        const result = originalSetItem.apply(this, arguments);

        if (key === 'activeButtonId') {
            const newValue = String(value).trim();
            if (newValue !== currentActiveId) {
                currentActiveId = newValue;
                logRed(`🔁 activeButtonId changed to: "${newValue}" — recalculating bags...`);
                runBagCalculation(newValue);
            }
        }

        return result;
    };

    // 🔄 Initial run
    const initialId = localStorage.getItem('activeButtonId');
    if (initialId) {
        currentActiveId = initialId.trim();
        runBagCalculation(currentActiveId);
    }
});